// @ts-expect-error strange ts error
import i18n from './index.d.ts'

export default i18n()
